import http from '@/services/http'
import { delayed } from '@/utils'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    applications: [],
    submissionsInProgress: [],
  },
  mutations: {
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    SET_APPLICATIONS_DATA(state, applications) {
      state.applications = applications
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },

    MARK_AS_SUBMITTED(state, { organizationId }) {
      state.applications = state.applications.map((application) => {
        if (application.organization.id === organizationId) {
          application.state = 'submitted'
          application.submitted_at = new Date()
        }
        return { ...application }
      })
    },
    START_SUBMIT(state, { organizationId }) {
      if (state.submissionsInProgress.indexOf(organizationId) < 0) {
        state.submissionsInProgress.push(organizationId)
      }
    },
    STOP_SUBMIT(state, { organizationId }) {
      state.submissionsInProgress = state.submissionsInProgress.filter(
        (orgId) => orgId !== organizationId,
      )
    },
  },
  getters: {
    isSubmitInProgress: (state) => (organizationId) => {
      return state.submissionsInProgress.indexOf(organizationId) >= 0
    },
    hasPendingApplications: (state) => {
      return state.applications.filter(
        (application) => !application.submitted_at,
      ).length
    },
  },
  actions: {
    async fetch({ commit, state }, { startupId }) {
      commit('START_FETCH')
      const url = `/startups/${startupId}/applications`
      try {
        const response = await delayed(http.getAuthed(url), 0)
        commit('SET_APPLICATIONS_DATA', response.data)
        return state.applications
      } finally {
        commit('STOP_FETCH')
      }
    },
    async submit({ commit }, { startupId, organizationId }) {
      commit('START_SUBMIT', { organizationId })
      const url = `/startups/${startupId}/applications/submit`
      try {
        const request = http.postAuthed(url, {
          organization_id: organizationId,
        })
        await delayed(request, 1000)
        commit('MARK_AS_SUBMITTED', { organizationId })
      } finally {
        commit('STOP_SUBMIT', { organizationId })
      }
    },
  },
}
